import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import { Route, Redirect } from 'react-router';
import classnames from 'classnames';
import { ToastContainer } from 'react-toastify';

import Header from '../components/Header/';
import Sidebar from '../components/Sidebar/';
import Breadcrumb from '../components/Breadcrumb/';
//chat sidebar

import Footer from '../components/Footer/';
// import Autocomplete from '../components/Autocomplete';

// Dashboard All
import HomeAdminScreen from './dashboard/home_admin.js'
// Asset Screen
import AssetScreen from './dashboard/asset/asset.js'
import AssetRegistrationScreen from './dashboard/asset/form/registration.js'
import AssetDetailScreen from './dashboard/asset/form/detail.js'
// import PhotoScreen from './dashboard/asset/photo.js'
// import TrackingScreen from './dashboard/asset/tracking.js'
// Location Screen
import LocationScreen from './dashboard/location/location.js'
import SiteScreen from './dashboard/location/site.js'
import CoverageScreen from './dashboard/location/coverage.js'
// Master Screen
import AssetStatusScreen from './dashboard/master/asset_status.js'
import AssetTypeScreen from './dashboard/master/asset_type.js'
import ContactScreen from './dashboard/master/contact.js'
import DepartementScreen from './dashboard/master/departement.js'
import SiteStatusScreen from './dashboard/master/site_status.js'
import SiteTypeScreen from './dashboard/master/site_type.js'
import MaintenanceTypeScreen from './dashboard/master/maintenance_type.js'
import ContractorScreen from './dashboard/master/contractor.js'

//Tenant Setting
import TenantSettingScreen from './dashboard/master/tenant_setting.js'
// User Screen
import RoleScreen from './dashboard/user/role.js'
import UserScreen from './dashboard/user/user.js'
import UserSettingsScreen from './dashboard/user/settings.js'
// Page
import Page404Screen from './dashboard/page/page404.js'
import RestrictionScreen from './dashboard/page/restriction.js'
import UnderContructionScreen from './dashboard/page/undercontruction.js'
// Locate Asset Screen
import LocateAssetScreen from './dashboard/asset/locate.js'

/* ==== TOP MENU ==== */
// Home
import HomeUserScreen from './dashboard/home/home.js'
import BookaToolScreen from './dashboard/home/book_a_tool.js'

// Assets/tools
import SimpleAssetScreen from './dashboard/asset/simple_asset.js'

// Job
import JobScreen from './dashboard/job/job.js'
import EditSiteScreen from './dashboard/job/edit_site.js'
import JobStockCheckScreen from './dashboard/job/job_stock_check.js'
import JobStockCheckDetailScreen from './dashboard/job/job_stock_detail.js'

// Users
import UserHaveAssetScreen from './dashboard/user/user_have_asset.js'

// Reports
import ReportScreen from './dashboard/report/report.js';
// Billing
import BillingScreen from './dashboard/billing/billing.js';

// Maintenance
import MaintenanceScreen from './dashboard/maintenance/maintenance.js';
import MaintenancByAssetScreen from './dashboard/maintenance/maintenance_by_asset.js';

// Booking
import BookingScreen from './dashboard/booking/booking.js';

// Request
import RequestScreen from './dashboard/request/request.js';

// remainder
import RemainderByWorkScreen from './dashboard/remainder/remainder_by_work.js';

// Superadmin
import TenantScreen from './dashboard/tenant/tenant.js'
import TenantListScreen from './dashboard/tenant/tenant_list.js'
import CurrencyScreen from './dashboard/superuser/currency/currency.js'
import CityScreen from './dashboard/superuser/city/'
import CountryScreen from './dashboard/superuser/country'
import ProvinceScreen from './dashboard/superuser/province'
import BusinessModelScreen from './dashboard/superuser/business_model'
import SuperuserSettingsScreen from './dashboard/superuser/user/settings.js'


import FormScreen from './dashboard/form/form.js'

// import 'react-toastify/dist/ReactToastify.min.css';

//chatting
import Aside from '../components/Aside/';

//QRreader
import QRReaderScreen from './dashboard/qrReader/QRReader.js';

//import
import ImportScreen from './dashboard/master/import.js';

// Online Detector
import OnlineDetector from '../components/OnlineDetector/OnlineDetector.js';

import CheckVersion from 'component/CheckVersion.js'

class Dashboard extends Component {
    constructor(){
        super()
        this.state = {
            notificationCount   : 0,
            confirmation  : {
              CounterElement    : '',
            },
            in_unconfirmed      : 0,
            out_unconfirmed     : 0,
            flash : {
              flashing          : null,
              in_flash          : null,
              out_flash         : null,
            }
        }

        this._isMounted = false

        this.setOutUnconfirmed          = this.setOutUnconfirmed.bind(this)
        this.setInUnconfirmed           = this.setInUnconfirmed.bind(this)
        this.setUnconfirmedConfirmation = this.setUnconfirmedConfirmation.bind(this)
        this.setFlashing                = this.setFlashing.bind(this)
        this.setNotificationCounter     = this.setNotificationCounter.bind(this)
        this.incrementReassignCounter   = this.incrementReassignCounter.bind(this)
        this.decrementReassignCounter   = this.decrementReassignCounter.bind(this)
        this.loadDataMsg                = this.loadDataMsg.bind(this)
    }

    setNotificationCounter(notificationCount){
        if(this._isMounted) {
            this.setState({notificationCount})
        }
    }

    setInUnconfirmed(in_unconfirmed){
        if(this._isMounted) {
            this.setState({in_unconfirmed})
        }
    }

    setOutUnconfirmed(out_unconfirmed){
        if(this._isMounted) {
            this.setState({out_unconfirmed})
        }   
    }   

    setFlashing(flashing, in_flash, out_flash){
        if(this._isMounted) {
            this.setState({
                flash : {
                    flashing,
                    in_flash,
                    out_flash
                }
            })
        }
    }

    setUnconfirmedConfirmation(in_unconfirmed, out_unconfirmed, flashing, in_flash, out_flash){
        var el = '';
        el = <span>
            {in_unconfirmed > 0 && <span className={classnames("badge badge-pill badge-danger", {'pulse-only':in_flash})}>in : {in_unconfirmed || 0}</span> }
            &nbsp;
            {out_unconfirmed > 0 && <span className={classnames("badge badge-pill badge-danger", {'pulse-only':out_flash})}>out : {out_unconfirmed || 0}</span> }
        </span>

        if(this._isMounted) {
            this.setState({
                confirmation: {
                    CounterElement: el
                }
            })
        }
    }

    incrementReassignCounter(type, value = null) {
        let incValue = value
        if(type === 'in') {
            if (value === null){
                incValue = this.state.in_unconfirmed
            }
            this.setInUnconfirmed(
                incValue + 1
            )
        } else {
            if (value === null){
                incValue = this.state.out_unconfirmed
            }
            this.setOutUnconfirmed(
                incValue + 1
            )
        }

        this.setUnconfirmedConfirmation(
            this.state.in_unconfirmed,
            this.state.out_unconfirmed,
            this.state.flash.flashing,
            this.state.flash.in_flash,
            this.state.flash.out_flash
        )
    }

    decrementReassignCounter(type) {
        if(type === 'in') {
            this.setInUnconfirmed(
                this.state.in_unconfirmed - 1
            )
        } else {
            this.setOutUnconfirmed(
                this.state.out_unconfirmed - 1
            )
        }

        this.setUnconfirmedConfirmation(
            this.state.in_unconfirmed,
            this.state.out_unconfirmed,
            this.state.flash.flashing,
            this.state.flash.in_flash,
            this.state.flash.out_flash
        )
    };

    loadDataMsg(data = null, type){
        if(this.homeUser !== undefined){
            if(this.homeUser.assetList !== undefined){
                switch (type) {
                    case 'qr-accept':
                        this.homeUser.assetList.hardReload();
                        break;
                    case 'accept':
                        this.homeUser.assetList.updateRow(data, true);
                        break;
                    case 'register':
                        this.homeUser.assetList.updateRow(data);
                        break;
                    case 'move':
                        this.homeUser.assetList.updateRowAfterMove(data);
                        break;
                    default:
                        break;
                }
            }
            if(this.homeUser.incomingMessageList !== undefined){
                switch (type) {
                    case 'accept':
                        this.homeUser.incomingMessageList.updateRow(data);
                        break;
                    case 'register':
                        this.homeUser.incomingMessageList.insertNewRow(data);
                        break;
                    default:
                        break;
                }
            }
        }

        if(this.header !== undefined){
			this.header.updateData(data, type)
        }
        return
    }

    componentDidMount = () => {
      this._isMounted = true
    }
    

    componentWillUnmount = () => {
        this._isMounted = false
    }

    render() {
        const homeUserScreen = () => {
          return(
            <HomeUserScreen
              {...this.props}
              setUnconfirmedConfirmation  = {this.setUnconfirmedConfirmation}
              setOutUnconfirmed           = {this.setOutUnconfirmed}
              setInUnconfirmed            = {this.setInUnconfirmed}
              setFlashing                 = {this.setFlashing}
              onRef                       = {ref => (this.homeUser = ref)}

              inUnconfirmed               = {this.state.in_unconfirmed}
              outUnconfirmed              = {this.state.out_unconfirmed}
              flash                       = {this.state.flash}
              confirmation                = {this.state.confirmation}
            />
          )
        }
        return (
          <div className="app">
            <CheckVersion />
            <Header
                ParentProps= {this.props}
                notificationCount= {this.state.notificationCount}
                onRef= {ref => this.header = ref}
            />
            <div className="app-body">
              <ToastContainer position="top-center" type="default" autoClose={5000} hideProgressBar={true} newestOnTop={false} closeOnClick pauseOnHover />
              <OnlineDetector />
              <Sidebar {...this.props} Home={HomeAdminScreen} />
              <main className="main">

                <Breadcrumb {...this.props} />
                <div className="container-fluid">

                  <Switch>
                    {/* Sidebar Dashboard for  */}
                    <Redirect exact from="/" to="/login" />
                    <Route exact path="/home" name="HomeUser" render={homeUserScreen}/>
                    <Route exact path="/home/book-a-tool" name="BookaTool" component={BookaToolScreen}/>
                    <Route exact path="/home/maintenance-list/:AssetAlias/:AssetName/:Owner" name="MaintenancByAsset" component={MaintenancByAssetScreen}/>

                    {/* Sidebar Asset */}
                    <Route exact path="/assets" name="SimpleAsset" component={SimpleAssetScreen}/>
                    <Route exact path="/assets/maintenance-list/:AssetAlias/:AssetName/:Owner" name="MaintenancByAsset" component={MaintenancByAssetScreen}/>
                    <Route exact path="/asset/request-asset" name="UnderContruction" component={UnderContructionScreen}/>

                    {/* Sidebar Job */}
                    <Route exact path="/job" name="Job" component={JobScreen}/>
                    <Route exact path="/job/edit-site" name="RequestJob" component={EditSiteScreen}/>
                    <Route exact path="/job/job-stock-check/:SiteAlias/:SiteName" name="JobStockCheck" component={JobStockCheckScreen}/>
                    <Route exact path="/job/maintenance-list/:AssetAlias/:AssetName/:Owner" name="MaintenancByAsset" component={MaintenancByAssetScreen}/>
                    <Route exact path="/job/Job-stock-check-detail/:StockAlias/:SiteName" name="JobStockCheckDetail" component={JobStockCheckDetailScreen}/>

                    {/* Sidebar User */}
                    <Route exact path="/user" name="UserHaveAsset" component={UserHaveAssetScreen}/>
                    <Route exact path="/user/request-user" name="UnderContruction" component={UnderContructionScreen}/>

                    {/* Sidebar Report */}
                    <Route exact path="/report" name="Report" component={ReportScreen}/>
                    {/*<Route exact path="/report/request-report" name="UnderContruction" component={UnderContructionScreen}/>*/}

                    {/* Sidebar Admin */}
                    {/*<Route path="/admin" name="UnderContruction" component={LocateAssetScreen}/>*/}
                    <Redirect exact from="/admin" to="/admin/all-activities" />
                    <Route exact path="/admin/all-activities" name="Home" component={HomeAdminScreen}/>
                    <Route exact path="/admin/filter/:Filter/:Alias" name="Home" component={HomeAdminScreen}/>
                    <Route exact path="/admin/master-asset" name="Asset" component={AssetScreen}/>
                    <Route exact path="/admin/master-asset-registration" name="AssetRegistration" component={AssetRegistrationScreen}/>
                    <Route exact path="/admin/master-asset-details-:Alias" name="AssetDetailScreen" component={AssetDetailScreen}/>
                    <Route exact path="/admin/locate-asset" name="LocateAsset" component={LocateAssetScreen}/>
                    <Route exact path="/admin/booking" name="Booking" component={BookingScreen}/>
                    <Route exact path="/admin/billing" name="Billing" component={BillingScreen}/>
                    <Route exact path="/admin/maintenance" name="Maintenance" component={MaintenanceScreen}/>
                    <Route exact path="/admin/maintenance/remainder-list/:Alias/:AssetName" name="RemainderScreen" component={RemainderByWorkScreen}/>
                    <Route exact path="/admin/remainder-list" name="RemainderScreen" component={RemainderByWorkScreen}/>
                    <Route exact path="/admin/request" name="Request" component={RequestScreen}/>
                    <Route exact path="/admin/job-stock-check" name="JobStockCheck" component={JobStockCheckScreen}/>

                    <Route exact path="/research/form" name="Form" component={FormScreen}/>
                    {/* Sidebar Data Master */}
                    <Route exact path="/data-master" name="UnderContruction" component={UnderContructionScreen}/>

                    <Redirect exact from="/data-master/location" to="/data-master/location/location" />
                    <Route path="/data-master/location/location" name="Location" component={LocationScreen}/>
                    <Route path="/data-master/location/site" name="Location-Site" component={SiteScreen}/>
                    <Route path="/data-master/location/coverage" name="Location-Coverage" component={CoverageScreen}/>

                    <Redirect exact from="/data-master/master" to="/data-master/master/asset-status" />
                    <Route path="/data-master/master/asset-status" name="Master-Asset-Status" component={AssetStatusScreen}/>
                    <Route path="/data-master/master/asset-type" name="Master-Asset-Type" component={AssetTypeScreen}/>
                    {/*<Route path="/data-master/master/business-model" name="Master-Business-Model" component={BusinessModelScreen}/>*/}
                    <Route path="/data-master/master/contact" name="Master-Contact" component={ContactScreen}/>
                    <Route path="/data-master/master/contractor" name="Master-Contractor" component={ContractorScreen}/>
                    <Route path="/data-master/master/departement" name="Master-Departement" component={DepartementScreen}/>
                    <Route path="/data-master/master/site-status" name="Master-Site-Status" component={SiteStatusScreen}/>
                    <Route path="/data-master/master/site-type" name="Master-Site-Type" component={SiteTypeScreen}/>
                    <Route path="/data-master/master/maintenance-type" name="Master-Maintenance-Type" component={MaintenanceTypeScreen}/>

                    <Redirect exact from="/data-master/user" to="/data-master/user/user" />
                    <Route path="/data-master/user/role" name="User-Role" component={RoleScreen}/>
                    <Route path="/data-master/user/user" name="User" component={UserScreen}/>
                    <Route path="/user/settings" name="User-Settings" component={UserSettingsScreen}/>

                    <Route path="/data-master/tenant-setting" name="Tenant-Sesttings" component={TenantSettingScreen}/>
                    <Route path="/data-master/import" name="Import" component={ImportScreen}/>


                    {/* Superadmin page*/}
                    <Redirect exact from="/su" to="/su/tenant-list" />
                    <Route path="/su/tenant/:mode/:id" name="Create-Tenant" component={TenantScreen}/>
                    <Route path="/su/tenant-list" name="Tenant-List" component={TenantListScreen}/>

                    <Route path="/su/currency" name="Currency" component={CurrencyScreen}/>
                    <Route path="/su/city" name="City" component={CityScreen}/>
                    <Route path="/su/country" name="Country" component={CountryScreen}/>
                    <Route path="/su/province" name="Province" component={ProvinceScreen}/>
                    <Route path="/su/business-model" name="Business-Model" component={BusinessModelScreen}/>
                    <Route path="/su/user/settings" name="User-Settings" component={SuperuserSettingsScreen}/>

                    {/* QRReader page */}
                    <Route path="/qrreader" name="QR-Reader" component={QRReaderScreen}/>

                    <Route path="/page/restriction/" name="restriction" component={RestrictionScreen}/>
                    <Route path="*" name="Page-404" component={Page404Screen}/>

                    

                  </Switch>
                </div>
                {/*<ChatArea {...this.props} />*/}
              </main>
                <Aside
                    {...this.props}
                    setUnconfirmedConfirmation  = {this.setUnconfirmedConfirmation}
                    setNotificationCounter      = {this.setNotificationCounter}
                    setOutUnconfirmed           = {this.setOutUnconfirmed}
                    setInUnconfirmed            = {this.setInUnconfirmed}
                    setFlashing                 = {this.setFlashing}
                    incrementReassignCounter    = {this.incrementReassignCounter}
                    decrementReassignCounter    = {this.decrementReassignCounter}
                    loadDataReassign            = {this.loadDataMsg}

                    inUnconfirmed               = {this.state.in_unconfirmed}
                    outUnconfirmed              = {this.state.out_unconfirmed}
                    flash                       = {this.state.flash}
                />
            </div>

            <Footer />
          </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard.js